import React, { useState } from "react";
import "./Register.scss";
import { toast } from "react-toastify";
import axios from "axios";
import privacyPDF from "../../../Assets/Documents/privacy.pdf";

const Register = () => {
  // const registerHandler = () => toast.info("Coming soon...");
  const [email, setEmail] = useState(() => "");
  const [emailErrorMessage, setEmailErrorMessage] = useState(() => "");
  const [disableBtn, setDisableBtn] = useState(() => false);

  const validateEmail = () => {
    let emailError;

    if (!email) {
      emailError = "Email field can't be empty";
      setEmailErrorMessage(emailError);
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      emailError = "Invalid email!";
      setEmailErrorMessage(emailError);
    } else {
      submitEmail();
    }
  };

  const sendEmailWithEnterKey = (event) => {
    if (event.key === "Enter") {
      validateEmail();
    }
  };

  const submitEmail = async () => {
    try {
      const response = await axios.post(
        "https://jupiter-test.com/api/invitation/subscribe-zixxar",
        {
          email: email,
        }
      );
      if (response.status === 200) {
        toast.success("Registered successfully!", {
          toastId: "success-registration",
        });
        setDisableBtn(true);
        setEmail("");
      }
    } catch (err) {
      console.log(err);
      toast.error("An error occured. Please try again later!", {
        toastId: "register-err",
      });
    }
  };

  return (
    <section id="event-subscribe" className=" register-section-event">
      <div className="large-container d-flex flex-column align-items-center">
        {/* <RegisterLogo className="register-logo" /> */}
        {/* <h2 className="font-size-80 font-pnb my-5 text-center">Join Us.Be you.</h2> */}
        {/* <button className="register-btn zixxar-reverse-gradient" onClick={() => console.log("sal")}>
                    <div className="inner-register-btn font-size-24 font-pnm">Register now</div>
                </button> */}
        <div className="register-container p-3 p-lg-5 d-flex align-items-center justify-content-center gap-2 flex-column">
          <span className="font-size-48 font-pnb text-center text-white">
            Never miss an important update
          </span>
          <span className="font-size-24 font-pnr text-center color-light-grey">
            Only important news and sales. Never spam.
          </span>
          <div
            className={`mt-4 input-container d-flex align-items-center justify-content-center position-relative w-100 ${
              emailErrorMessage !== "" ? "red-warning" : ""
            }`}
          >
            <input
              onKeyDown={sendEmailWithEnterKey}
              disabled={disableBtn}
              type="text"
              placeholder={`${!disableBtn ? "Enter your email" : "Registred"}`}
              className={`font-pnr font-size-32 register-input ${
                emailErrorMessage !== "" ? "red-border" : ""
              }`}
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                if (emailErrorMessage !== "") setEmailErrorMessage("");
              }}
            />
            <button
              disabled={disableBtn}
              className={`register-btn font-size-32 font-pnr ${
                disableBtn ? "cursor-disable" : ""
              }`}
              onClick={() => validateEmail()}
            >
              <span>Subscribe now</span>
            </button>
          </div>
          <p className="mt-0 pt-0 error-message font-pnr text-center">
            {emailErrorMessage}
          </p>
          <span className="font-size-16 font-pnr text-center mt-4 text-white">
            We’ll never share your details with third parties. View our{" "}
            <span
              className="privacy-policy"
              onClick={() => window.open(privacyPDF)}
            >
              Privacy Policy
            </span>{" "}
            for more info.
          </span>
        </div>
      </div>
    </section>
  );
};

export default Register;
